import { notifyError } from '../services/error-handler';

const getProductListKeyBySKU = (sku: string) => {
  return `pl-${sku}`;
};

const getProductListFromStorageByKey = (key: string) => {
  try {
    const productList = localStorage.getItem(key);

    if (productList) {
      return decodeURIComponent(productList);
    }
  } catch (error) {
    notifyError(error);
  }

  return null;
};

export const getProductListFromStorageBySKU = (sku: string) => {
  const productKey = getProductListKeyBySKU(sku);
  const productList = getProductListFromStorageByKey(productKey);

  return productList || 'PDP';
};

export const cleanProductListBySKU = (sku: string) => {
  try {
    const productKey = getProductListKeyBySKU(sku);
    localStorage.removeItem(productKey);
  } catch (error) {
    notifyError(error);
  }
};
